// extracted by css-extract-rspack-plugin
export default {"charsLeft":"_3280b628"};